import React from 'react';
import HelpPopover from '~/components/HelpPopover';
import { EmailHelpText } from './EmailHelpText';

export class EmailHelpPopover extends React.Component {
    render() {
        return (
            <HelpPopover label="Can't find your email address?" popperClassName="emailHelpPopover">
                <EmailHelpText />
            </HelpPopover>
        );
    }
}
